import { Inject, Injectable, Optional } from "@angular/core";
import {
	HttpClient,
	HttpHeaders,
	HttpParams,
	HttpResponse,
	HttpEvent,
} from "@angular/common/http";

// import { ResponseContentType } from '@angular/common/http';

import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

import { Observable } from "rxjs";

import {
	DbService,
	Configuration,
	ConfigurationParameters,
	BASE_PATH,
} from "papi-client-ng2";

// import { CustomHttpUrlEncodingCodec } from 'papi-client-ng2/encoder';
import { HttpUrlEncodingCodec } from "@angular/common/http";
import { environment } from "environments/environment";

/**
 * CustomHttpUrlEncodingCodec
 * Fix plus sign (+) not encoding, so sent as blank space
 * See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
 */
export class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
	constructor() {
		super();
	}
	
	encodeKey(k: string): string {
		k = super.encodeKey(k);
		return k.replace(/\+/gi, "%2B");
	}
	encodeValue(v: string): string {
		v = super.encodeValue(v);
		return v.replace(/\+/gi, "%2B");
	}
}

@Injectable()
export class PapiDbService extends DbService {
	constructor(
		protected httpClient: HttpClient,
		basePath: string,
		configuration: Configuration
	) {
		super(httpClient, basePath, configuration);
	}
	/**
	 *
	 * Get a floorplan as a blob.
	 * @param id ID of the Floorplan instance.
	 * @param attachment True to download the image.
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public getFloorplanFileAsBlob(
		id: number,
		attachment?: boolean,
		observe?: "body",
		reportProgress: boolean = false
	): Observable<Blob> {
		if (id === null || id === undefined) {
			throw new Error(
				"Required parameter id was null or undefined when calling getFloorplanFile."
			);
		}

		let queryParameters = new HttpParams({
			encoder: new CustomHttpUrlEncodingCodec(),
		});
		if (attachment !== undefined) {
			queryParameters = queryParameters.set(
				"attachment",
				<any>attachment
			);
		}

		let headers = this.defaultHeaders;

		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"]
			);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = ["image/png", "image/svg+xml"];
		let httpHeaderAcceptSelected: string | undefined =
			this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		let consumes: string[] = [
			"application/json",
			"application/x-www-form-urlencoded",
		];

		return this.httpClient.get(
			`${this.basePath}/db/Floorplan/${encodeURIComponent(
				String(id)
			)}/file`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress,
				responseType: "blob",
			}
		);
	}
	public createRoomByFloorPlan(createRoomFormData : FormData): Observable<any> {
		let apiUrl = environment.TEZZ_ADD_PAPI_PATH + '/room-geometry/';
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],

			);
		}
		// to determine the Content-Type header
		let consumes: string[] = [
			"application/json",
			"application/x-www-form-urlencoded",
		];
		let httpHeaderAcceptSelected: string | undefined =
			this.configuration.selectHeaderAccept(consumes);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post(apiUrl, createRoomFormData, { headers });
	}

	public createRoomsWithAI(createRoomFormData : FormData): Observable<any> {
		let apiUrl = environment.TEZZ_ADD_PAPI_PATH + '/process-pdf/';
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],

			);
		}
		// to determine the Content-Type header
		let consumes: string[] = [
			"application/json",
			"application/x-www-form-urlencoded",
		];
		let httpHeaderAcceptSelected: string | undefined =
			this.configuration.selectHeaderAccept(consumes);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post(apiUrl, createRoomFormData, { headers });
	}

	getCampusBuildings(
		organizationId: any,
		campusId: number
	): Observable<any> {
		const getCampusBuildingsUrl = '/campus/get-buildings/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + getCampusBuildingsUrl;
		let headers = this.defaultHeaders;
			// authentication (JWT) required
			if (this.configuration.apiKeys["Authorization"]) {
				headers = headers.set(
					"Authorization",
					this.configuration.apiKeys["Authorization"],


				);
			}
		const body = {
		organizationIds: organizationId,
		campusId: campusId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	addCampusBuildings(
		organizationId: string,
		perimeterId: number,
		buildingId: number
	): Observable<any> {
		const addCampusBuildingsUrl = '/campus/add-building/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + addCampusBuildingsUrl;
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],

			);
		}
		const body = {
			organization_id: organizationId,
			campus_id: perimeterId,
			perimeter_id: buildingId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	viewCampusBuildings(
		organizationId: string,
		perimeterId: number
	): Observable<any> {
		const viewCampusBuildingsUrl = '/campus/view-buildings/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + viewCampusBuildingsUrl;
		let headers = this.defaultHeaders;
			// authentication (JWT) required
			if (this.configuration.apiKeys["Authorization"]) {
				headers = headers.set(
					"Authorization",
					this.configuration.apiKeys["Authorization"],

				);
			}
		const body = {
		organization_id: organizationId,
		campus_id: perimeterId
		};

		return this.httpClient.post(apiUrl, body,{ headers });
	}

	listCampusBuildings(payload: {
		id: any;
		perimeter_id: any;
		label: any;
		address: any;
		type: string;
		limit: number;
		offset: number;
	}): Observable<any> {
		const listCampusBuildingsUrl = '/campus/get-building-details';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + listCampusBuildingsUrl;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
				headers = headers.set(
					"Authorization",
					this.configuration.apiKeys["Authorization"],

				);
			}

		return this.httpClient.post(apiUrl, payload, { headers });
	}

	deleteCampusBuilding(
		organizationId: number,
		perimeterId: number,
		campusId: number
	): Observable<any> {

		const deleteCampusBuildingUrl = '/campus/building-delete/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + deleteCampusBuildingUrl;

		let headers = this.defaultHeaders;

		// authentication (JWT) required
		if (this.configuration.apiKeys['Authorization']) {
			headers = headers.set(
				'Authorization',
				this.configuration.apiKeys["Authorization"],
			);
		}

		const body = {
			organization_id: organizationId,
			perimeter_id: perimeterId,
			campus_id: campusId
		};

		return this.httpClient.delete(apiUrl, {
			headers,
			body
		});
	}

	updateCampusBuildings(
		campusId: number,
		buildingIds: number[]
	): Observable<any> {
		const updateCampusBuildingsUrl = `/campus/${campusId}/buildings/update/`;
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + updateCampusBuildingsUrl;

		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],
			);
		}

		const body = {
			ids: buildingIds
		};

		return this.httpClient.patch(apiUrl, body, { headers });
	}

	getCampusRoles(): Observable<any> {
		const getCampusRoles = '/db/Action/getCampusRoles';
		const apiUrl = environment.PAPI_BASE_PATH + getCampusRoles;
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],
			);
		}

		return this.httpClient.post(apiUrl, {}, { headers });
	}

	getMaterialTypes(limit: number = 100): Observable<any> {
		const MaterialTypePath = '/db/MaterialType/findAndCountAll';
		const apiUrl = `${environment.PAPI_BASE_PATH}${MaterialTypePath}`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		const body = {
			"order": [["id", "DESC"]]
		}

		return this.httpClient.post(apiUrl, body, { headers });
	}

	public exportDirectGlb(buildingData: any, buildingName?: string, scale?: number, material_type?: string, material_id?: any): Observable<any> {
		const apiUrl = `${this.basePath}/api/export/direct-glb-files`;
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		const body: any = {
			buildingData,
			buildingName,
			scale,
			material_type,
			material_id
		};
		// Remove undefined fields
		Object.keys(body).forEach(k => body[k] === undefined && delete body[k]);
		return this.httpClient.post(apiUrl, body, { headers });
	}

	setPerimeterGlb(perimeterId: number, materialId: any): Observable<any> {
		const apiUrl = `${this.basePath}/db/Perimeter/PerimeterGlbMaterialId`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}

		const body = {
			perimeterId: perimeterId,
			materialId: materialId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	triggerGlbExport(perimeterId: number): Observable<any> {
		const apiUrl = `${this.basePath}/db/Perimeter/TriggerGlbExport`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}

		const body = {
			perimeterId: perimeterId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	getPerimeterGlb(perimeterId: number): Observable<any> {
		const apiUrl = `${this.basePath}/db/Perimeter/PerimeterGlb`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}

		let body = {
			perimeterId: perimeterId.toString(),
		}
		
	
		return this.httpClient.post(apiUrl, body, { headers });
	}
}

